export const SquaayIOSLink = "https://apps.apple.com/app/squaay/id6740501959";
export const SquaayAndroidLink = "https://play.google.com/store/apps/details?id=com.squaay.android";
export const SquaayRiderIOSLink = "https://apps.apple.com/ng/app/squaay-riders/id6744063986";
export const SquaayRiderAndroidLink = "https://play.google.com/store/apps/details?id=com.squaayriders.android";